document.addEventListener('DOMContentLoaded', () => {
  const WISHLIST_KEY = 'activet_wishlist_2026';
  let wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];

  const updateHeartUI = (handle, isActive) => {
    const hearts = document.querySelectorAll(`.favorite-toggle[data-product-handle="${handle}"]`);
    hearts.forEach(heart => {
      heart.classList.toggle('is-active', isActive);
      const icon = heart.querySelector('svg');
      if (icon) {
        icon.setAttribute('fill', isActive ? '#e63946' : 'none');
        icon.setAttribute('stroke', isActive ? '#e63946' : 'currentColor');
      }
    });
  };

  // Set initial states
  wishlist.forEach(handle => updateHeartUI(handle, true));

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.favorite-toggle');
    if (!toggle) return;

    const handle = toggle.getAttribute('data-product-handle');
    const index = wishlist.indexOf(handle);

    if (index === -1) {
      wishlist.push(handle);
      updateHeartUI(handle, true);
    } else {
      wishlist.splice(index, 1);
      updateHeartUI(handle, false);
    }

    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
  });
});